import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders,HttpParams}from '@angular/common/http';
import {DisplayFormComponent}from './display-form/display-form.component';

@Injectable({
  providedIn: 'root'
})
export class DisplayFormService {

  static urlport: any;

  constructor(private http:HttpClient) {
    DisplayFormService.urlport = "http://localhost:46292";
   }

   GetLayoutData() {
  //   debugger;
  //   let re = /\//gi;
  //  let username = "AroshaM";//sessionStorage.getItem("UserName");
  //  let mode = sessionStorage.getItem("Mode");
  //  let plants = sessionStorage.getItem("Plants");
  //  let factory = sessionStorage.getItem("Factory");
  //  let valueStream = sessionStorage.getItem("ValueStream");
  //  let startDate = sessionStorage.getItem("StartDate").replace(re, "-");
  //  let endDate = sessionStorage.getItem("EndDate").replace(re, "-");


  //   var parameters="uname=" + username + "&mode=" + mode + "&plant=" + plants + "&factory=" + factory + "&valueStream=" + valueStream + "&fromDate=" + startDate + "&toDate=" + endDate;

  //   var url=DisplayFormService.urlport + '/api/getSAPData/GetLayoutData?'+parameters;

  //   let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    
  //   return this.http.get(url, {headers:headers}).subscribe(
  //     data => {
  //         console.log("GET is successful ", data);
  //         if(data!=null)
  //         {
  //           sessionStorage.setItem("DisplayBoardOutput", data.toString());
  //         }
          
  //         //return data;
  //     },
  //     error => {
  //         console.log("Error", error);
  //     }
  //   );

   // return this.http.get(url, {headers:headers});

   }
}
